

import { Component, Mixins, Prop, Watch } from "vue-property-decorator";

import GlobalMixin from "@/mixins/global";
import Redirect from "@/mixins/redirect/redirect";
import IBListWithIconAndBadge from "@/components//List/ListWithIconAndBadge/ListWithIconAndBadge.vue";
import OperationDay from "@/components/OperationDay/OperationDay.vue";
import { $logout } from "@/api/auth/auth";

@Component({
	components: {
		OperationDay,
		IBListWithIconAndBadge
	}
})
export default class IBAside extends Mixins(GlobalMixin, Redirect) {

	@Prop({ type: Array, default: [] }) readonly headerList!: any[];
	@Prop({ type: Array, default: [] }) readonly list!: any[];
	@Prop({ type: Array, default: [] }) readonly sublist!: any[];

	public isMenu: boolean = false;
	appVersion: string = process.env.VUE_APP_VERSION || '';

	@Watch("$route")
	route() {
		if (window.innerWidth < 1720) {
			this.isMenu = false;
		}
	}

	menuOpen() {
		if (window.innerWidth < 768 || window.innerWidth > 1720) {
			return this.isMenu = !this.isMenu;
		}
	}

	signOut() {
		$logout();
	}

	mounted() {
		window.addEventListener("resize", () => {
			this.isMenu = window.innerWidth > 1720;
		});

		document.addEventListener("click", (e: Event) => {
			if (this.isMenu) {
				if (e.target === this.$refs.openAside) {
					this.menuOpen();
				}
			}
		});
	}
}

